// extracted by mini-css-extract-plugin
export default {"resize":"resize-module_resize_d7db04c9"};